import { common as commonFr } from './fr/common';
import { services as servicesFr } from './fr/services';
import { common as commonEn } from './en/common';
import { services as servicesEn } from './en/services';
import { common as commonAr } from './ar/common';
import { services as servicesAr } from './ar/services';
import { common as commonPt } from './pt/common';
import { services as servicesPt } from './pt/services';
import { common as commonEs } from './es/common';
import { services as servicesEs } from './es/services';

export const resources = {
  fr: {
    common: commonFr,
    services: servicesFr,
  },
  en: {
    common: commonEn,
    services: servicesEn,
  },
  ar: {
    common: commonAr,
    services: servicesAr,
  },
  pt: {
    common: commonPt,
    services: servicesPt,
  },
  es: {
    common: commonEs,
    services: servicesEs,
  },
};